// Generated by purs version 0.15.0
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var $$Set = function (x) {
    return x;
};
var udecodeSet = function (dictOrd) {
    return function (dictDecode) {
        return Unscramble.decodeSet(dictDecode)(dictOrd);
    };
};
var showSet = function (dictShow) {
    return Data_Set.showSet(dictShow);
};
var semigroupSet = function (dictOrd) {
    return Data_Set.semigroupSet(dictOrd);
};
var ordSet = function (dictOrd) {
    return Data_Set.ordSet(dictOrd);
};
var newtypeSet = {
    Coercible0: function () {
        return undefined;
    }
};
var monoidSet = function (dictOrd) {
    return Data_Set.monoidSet(dictOrd);
};
var foldableSet = Data_Set.foldableSet;
var eqSet = function (dictEq) {
    return Data_Set.eqSet(dictEq);
};
var encodeSet = function (dictEncode) {
    return {
        encode: (function () {
            var $10 = Foreign_Generic_Class.encode(Foreign_Generic_Class.arrayEncode(dictEncode));
            var $11 = Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray);
            var $12 = Data_Newtype.unwrap();
            return function ($13) {
                return $10($11($12($13)));
            };
        })()
    };
};
var decodeSet = function (dictOrd) {
    return function (dictDecode) {
        return {
            decode: (function () {
                var $14 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))((function () {
                    var $17 = Data_Newtype.wrap();
                    var $18 = Data_Set.fromFoldable(Data_Foldable.foldableArray)(dictOrd);
                    return function ($19) {
                        return $17($18($19));
                    };
                })());
                var $15 = Foreign_Generic_Class.decode(Foreign_Generic_Class.arrayDecode(dictDecode));
                return function ($16) {
                    return $14($15($16));
                };
            })()
        };
    };
};
export {
    $$Set as Set,
    newtypeSet,
    eqSet,
    ordSet,
    showSet,
    semigroupSet,
    monoidSet,
    udecodeSet,
    foldableSet,
    encodeSet,
    decodeSet
};
//# sourceMappingURL=index.js.map
